module.exports = __webpack_public_path__ + "img/foto_vijver.a96e2852.jpg";